// ABOUTME: Animation configuration and timing curves for Apple-inspired motion
// ABOUTME: Exports easing curves, variants, and animation utilities

// Animation disable flag (for testing or performance)
export const disableAnimations = {
  skipAnimations: false,
}

// Apple-inspired easing curves (as arrays for Framer Motion)
export const easing = {
  standard: [0.25, 0.1, 0.25, 1.0] as const,
  enter: [0.0, 0.0, 0.2, 1.0] as const,
  exit: [0.4, 0.0, 1.0, 1.0] as const,
  bounce: [0.34, 1.56, 0.64, 1.0] as const,
  dramatic: [0.16, 1.0, 0.3, 1.0] as const,
}

// Duration constants (in seconds for Framer Motion)
export const duration = {
  fast: 0.15,
  standard: 0.2,
  enter: 0.3,
  exit: 0.2,
  bounce: 0.5,
  dramatic: 0.8,
}

// Framer Motion variants for common patterns
export const variants = {
  fadeIn: {
    initial: { opacity: 0 },
    animate: { opacity: 1 },
    exit: { opacity: 0 },
    transition: { duration: duration.enter, ease: easing.enter },
  },

  slideUp: {
    initial: { opacity: 0, y: 20 },
    animate: { opacity: 1, y: 0 },
    exit: { opacity: 0, y: -10 },
    transition: { duration: duration.enter, ease: easing.enter },
  },

  scaleIn: {
    initial: { opacity: 0, scale: 0.95 },
    animate: { opacity: 1, scale: 1 },
    exit: { opacity: 0, scale: 0.95 },
    transition: { duration: duration.enter, ease: easing.enter },
  },

  bounceIn: {
    initial: { opacity: 0, scale: 0 },
    animate: { opacity: 1, scale: 1 },
    exit: { opacity: 0, scale: 0 },
    transition: { duration: duration.bounce, ease: easing.bounce },
  },
}

// Scroll reveal variant
export const scrollReveal = {
  initial: { opacity: 0, y: 40 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: '-100px' },
  transition: { duration: 0.6, ease: easing.enter },
}

// Stagger container for children
export const staggerContainer = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1,
    },
  },
}

export const staggerItem = {
  hidden: { opacity: 0, y: 20 },
  show: {
    opacity: 1,
    y: 0,
    transition: { ease: easing.enter },
  },
}

// Legacy compatibility
export const noAnimation = {
  initial: { opacity: 1 },
  animate: { opacity: 1 },
  exit: { opacity: 1 },
  transition: { duration: 0 },
}

export const noMotionProps = {
  whileHover: {},
  whileTap: {},
  animate: {},
  transition: { duration: 0 },
}
